import {
  login,
  userinfo,
  logout,
  loginID,
  loginPhone,
  phoneTwin,
  IsStore
} from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
const state = {
  token: getToken(),
  roles: [],
  user: ""
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_USER: (state, user) => {
    state.user = user;
  }
};

const actions = {
  // 手机登陆
  Login({ commit }, parame) {
    return new Promise((resolve, reject) => {
      login({ ...parame })
        .then(res => {
          if (res.access_token) {
            setToken(res.access_token);
            commit("SET_TOKEN", res.access_token);
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 账户登录
  LoginId({ commit }, parame) {
    console.log(parame);
    return new Promise((resolve, reject) => {
      loginID({ ...parame })
        .then(res => {
          res = res.data ? res.data : res;
          if (res.access_token) {
            setToken(res.access_token);
            localStorage.setItem("name", parame.username);
            localStorage.setItem("pwd", parame.password);
            commit("SET_TOKEN", res.access_token);
          }
          resolve(res);
        })
        .catch(error => {
          console.log(error, "error");
          reject(error);
        });
    });
  },
  // setToken
  SetToken({ commit }, token) {
    setToken(token);
    commit("SET_TOKEN", token);
  },
  // 智慧园区登录
  LoginPark({ commit }, parame) {
    return new Promise((resolve, reject) => {
      loginPhone({ ...parame })
        .then(res => {
          if (res.access_token) {
            setToken(res.access_token);
            // localStorage.setItem('name',parame.username);
            //           localStorage.setItem('pwd',parame.password);
            commit("SET_TOKEN", res.access_token);
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 数字孚生登录
  LoginTwin({ commit }, parame) {
    return new Promise((resolve, reject) => {
      phoneTwin({ ...parame })
        .then(res => {
          if (res.access_token) {
            setToken(res.access_token);
            // localStorage.setItem('name',parame.username);
            //           localStorage.setItem('pwd',parame.password);
            commit("SET_TOKEN", res.access_token);
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 判断商家是否入驻
  UserStore({ commit }, parame) {
    return new Promise((resolve, reject) => {
      IsStore({ ...parame })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 获取用户信息
  GetInfo({ commit }, state) {
    return new Promise((resolve, reject) => {
      userinfo()
        .then(res => {
          // if (data.roles && data.roles.length > 0) {
          //   commit('SET_ROLES', data.roles)
          // } else {
          //   reject('getInfo: roles must be a non-null array !')
          // }
          const data = res.data;
          localStorage.setItem("user", JSON.stringify(data));
          commit("SET_USER", data);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 登出
  LogOut({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_USER", "");
          // commit('SET_ROLES', [])
          localStorage.clear();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js